(ns ui.components.tab.zapkit-styles)

;; ----------------------------------------------------------------------------
;; AUTO-GENERATED FILE — DO NOT EDIT MANUALLY.
;; Regenerate via: scripts/convert_zapkit_json.bb <source>.json <output-dir-or-file>
;; (run from the project root directory).
;; Source: zapkit-components/src/components/Tab/styles.json
;; Source commit: 8644abea21d37bd068100f210e5dc397949779a3
;; ----------------------------------------------------------------------------

(def tab
  {:root
   {:base
    "tw2-flex tw2-flex-wrap tw2-items-end tw2-gap-tab-gap tw2-border-b tw2-border-separator-border",
    :compound-variants [],
    :default-variants {}},
   :item
   {:base
    "tw2-inline-flex tw2-items-center tw2-gap-tab-inner-gap tw2--mb-px tw2-border-b-2 tw2-px-tab-px tw2-py-tab-py tw2-text-label-md tw2-font-sans tw2-transition-colors motion-reduce:tw2-transition-none focus-visible:tw2-outline-none focus-visible:tw2-outline-2 focus-visible:tw2-outline-offset-2 focus-visible:tw2-outline-tab-border-active",
    :selected {:true "", :false ""},
    :disabled {:true "tw2-cursor-not-allowed", :false ""},
    :compound-variants
    [{:selected false,
      :disabled false,
      :class
      "tw2-border-transparent tw2-text-tab-text-inactive hover:tw2-border-tab-border-hover hover:tw2-text-tab-text-inactive-hover active:tw2-border-tab-border-pressed active:tw2-text-tab-text-inactive-hover active:tw2-opacity-80"}
     {:selected true,
      :disabled false,
      :class
      "tw2-border-tab-border-active tw2-text-tab-text-active hover:tw2-border-tab-border-active-hover active:tw2-border-tab-border-active-pressed active:tw2-opacity-80"}
     {:selected false,
      :disabled true,
      :class "tw2-border-transparent tw2-text-tab-text-disabled"}
     {:selected true,
      :disabled true,
      :class
      "tw2-border-tab-border-disabled tw2-text-tab-text-disabled tw2-opacity-80"}],
    :default-variants {:selected false, :disabled false}},
   :_meta
   {:tokens
    ["label-md-font-size"
     "label-md-font-weight"
     "label-md-line-height"
     "separator-border"
     "spacing-tab-gap"
     "spacing-tab-inner-gap"
     "spacing-tab-px"
     "spacing-tab-py"
     "tab-border-active"
     "tab-border-active-hover"
     "tab-border-active-pressed"
     "tab-border-disabled"
     "tab-border-hover"
     "tab-border-pressed"
     "tab-text-active"
     "tab-text-disabled"
     "tab-text-inactive"
     "tab-text-inactive-hover"],
    :generated-from "src/components/Tab/Tab.styles.ts"}})
